import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSurvey } from '@wlb/shared/context/SurveyContext';
import useHydrateSurvey from '@wlb/shared/hooks/useHydrateSurvey';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { BrandLogo } from '../components/ui/BrandLogo';
import { AuthFlowLayout } from '../components/layout/AuthFlowLayout';
import { PORTRAIT_PATH, isPortraitEditMode, withEditFlag } from '../features/profile/portraitEdit';

/** Values are the MainGoal enum names the shared mapper turns into API ints. */
const OPTIONS = [
  { labelKey: 'loseWeight', value: 'LoseWeight' },
  { labelKey: 'stayConsistent', value: 'StayConsistent' },
  { labelKey: 'getHealthier', value: 'GetHealthier' },
  { labelKey: 'maintainWeight', value: 'MaintainWeight' },
] as const;

export function SurveyQ1() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isEdit = isPortraitEditMode(searchParams);
  const { surveyData, setSurveyAnswer } = useSurvey();
  useHydrateSurvey(isEdit);
  const [selected, setSelected] = useState<string | null>(surveyData.mainGoal);

  // The saved answer can arrive after mount, once the portrait data hydrates.
  useEffect(() => {
    setSelected(current => current ?? surveyData.mainGoal);
  }, [surveyData.mainGoal]);

  return (
    <AuthFlowLayout>
      <div className="auth-flow__card auth-flow__survey-question">
        <div className="auth-flow__progress" aria-hidden><span /></div>
        <button className="auth-flow__back" type="button" onClick={() => navigate(isEdit ? PORTRAIT_PATH : '/survey')}>‹ {t('common.buttons.back')}</button>
        <BrandLogo compact className="auth-flow__brand" />
        <h1 className="auth-flow__heading">{t('survey.q1.question')}</h1>
        <div className="auth-flow__survey-options">
          {OPTIONS.map(option => (
            <button
              key={option.value}
              type="button"
              className={`auth-flow__survey-option${selected === option.value ? ' auth-flow__survey-option--selected' : ''}`}
              onClick={() => {
                setSelected(option.value);
                setSurveyAnswer('mainGoal', option.value);
              }}
            >
              {t(`survey.q1.${option.labelKey}`)}
              {selected === option.value && <span aria-hidden>✓</span>}
            </button>
          ))}
        </div>
        <button className="auth-flow__primary" type="button" disabled={!selected} onClick={() => navigate(withEditFlag('/survey/q2', isEdit))}>{t('common.buttons.next')}</button>
      </div>
    </AuthFlowLayout>
  );
}
